import { render, staticRenderFns } from "./study_advice_report.vue?vue&type=template&id=e1fa9718&scoped=true"
import script from "./study_advice_report.vue?vue&type=script&lang=js"
export * from "./study_advice_report.vue?vue&type=script&lang=js"
import style0 from "./study_advice_report.vue?vue&type=style&index=0&id=e1fa9718&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1fa9718",
  null
  
)

export default component.exports